<template>
  <div id="menu">
    <div id="header" :class="{ light: !darkMode }">
      <div id="name" class="title1" :class="{ light: !darkMode }">
        {{ $t("menu.name") }}
      </div>
      <div id="job" class="title2" :class="{ light: !darkMode }">
        {{ $t("menu.job") }}
      </div>
    </div>
    <nav id="step-list" :class="{ light: !darkMode }">
      <router-link
        v-for="(route, index) in routeList"
        :key="index"
        :to="route.path"
        class="step-container title2"
        :class="{ light: !darkMode }"
        >{{ $t("menu." + route.name) }}</router-link
      >
    </nav>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import store from "@/store";

export default defineComponent({
  name: "Menu",
  data() {
    return {
      routeList: [
        { name: "home", path: "/" },
        { name: "project", path: "/project" },
        { name: "contact", path: "/contact" },
        //{ name: "FAQ", path: "/faq" },
      ],
      currentPath: this.$route.path,
    };
  },
  computed: {
    darkMode(): boolean {
      return store.state.darkMode;
    },
  },
  watch: {
    $route(to) {
      // Update currentPath when the route changes
      this.currentPath = to.path;
    },
  },
});
</script>

<style scoped>
@font-face {
  font-family: "NeueMontreal-Regular";
  src: url("../font/NeueMontreal-Regular.otf") format("otf");
  /* Ajoutez d'autres formats de police si nécessaire */
}

#menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  position: absolute;
  z-index: 100;
  top: 20px;
  left: 20px;
}

#header {
  border: solid 1px #ececec;
  max-width: calc(100% - 50px);
  border-radius: 5px;
  background: rgba(33, 33, 33, 0.8);
  backdrop-filter: blur(2px);
  box-shadow: 0 4px 15px rgba(33, 33, 33, 0.2);
  padding-left: 5px;
  padding-right: 5px;
}

#header.light {
  border-color: #212121;
  background: rgba(236, 236, 236, 0.8);
  box-shadow: 0 4px 15px rgba(236, 236, 236, 0.2);
}

#name {
  letter-spacing: 2px;
  padding: 2px 5px 0px 5px;
}

#job {
  padding: 5px;
  padding-top: 0px;
}

#step-list {
  margin-top: 20px;
  width: 95px;
  border: solid 1px #ececec;
  border-radius: 5px;
  background: rgba(33, 33, 33, 0.8);
  backdrop-filter: blur(2px);
  box-shadow: 0 4px 15px rgba(33, 33, 33, 0.2);
  padding-left: 10px;
  padding-right: 10px;
}

#step-list.light {
  border-color: #212121;
  background: rgba(236, 236, 236, 0.8);
  box-shadow: 0 4px 15px rgba(236, 236, 236, 0.2);
}
.step-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  text-decoration: none;
  color: #ececec;
  font-family: NeueMontreal-Regular, monospace;
  opacity: 1;
  transition: opacity 0.3s ease, margin-left 1s ease-out;
}

.step-container.light {
  color: #212121;
}

.step-container.router-link-exact-active {
  margin-left: 22px;
}

@media screen AND (min-width: 768px) {
  #menu {
    left: 30px;
    top: 30px;
  }

  #header {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px;
  }

  #name {
    padding-top: 5px;
  }

  #job {
    padding-bottom: 10px;
  }

  #step-list {
    width: 105px;
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 10px;
  }

  .step-container {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}

@media screen AND (hover: hover) AND (pointer: fine) {
  .step-container:hover {
    opacity: 0.25;
  }
}

@media screen AND (min-width: 1200px) {
  #step-list {
    width: 135px;
  }
}
</style>
